export function highestInvoiceFirst(first, second) {
  const firstNumber = String(first.numeroFacture ?? first.IdFacture ?? "").trim();
  const secondNumber = String(second.numeroFacture ?? second.IdFacture ?? "").trim();
  if (!firstNumber || !secondNumber) return firstNumber ? -1 : secondNumber ? 1 : 0;
  return secondNumber.localeCompare(firstNumber, "fr", {numeric: true, sensitivity: "base"});
}
